import React from "react";
import { ErrorMessage, Field } from "formik";
import { FormikDropdown } from "../../../FormikDropdown";
import { Flex } from "../../../Flex";
import { FormInputErrorMessage } from "../../../FormInputErrorMessage";

interface Props {
  id: string;
}

export const DisconnectionPropertyDetailsType: React.FC<Props> = ({ id }) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.3}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      maxWidth={"422px"}
      mb={[3, 3, 3, 0]}
      mt={4}
    >
      <Field
        id={"propertyDetails.type"}
        name={"propertyDetails.type"}
        label="Property Type"
        items={["Residential", "Commercial"]}
        visibleItems={2}
        placeholder="Select Item"
        component={FormikDropdown}
      />
      <ErrorMessage
        name="propertyDetails.type"
        className="field-error"
        component={FormInputErrorMessage}
      />
    </Flex>
  );
};
